angular.module('component-input', [])
	.directive('ctInputContainer', ['$parse', ctInputContainerDirective])
	.directive('input', cdInputDirective);

function ctInputContainerDirective($parse) {
	return {
		restrict: 'A',
		link: postLink,
		controller: ['$scope', '$element', '$attrs', '$animate', ContainerCtrl]
	};

	function postLink(scope, element) {
		element.addClass('ct-input-container');
	}

	function ContainerCtrl($scope, $element, $attrs, $animate) {
		var self = this;

		self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);

		self.element = $element;
		self.setFocused = function (isFocused) {
			$element.toggleClass('ct-input-focused', !!isFocused);
		};
		self.setHasValue = function (hasValue) {
			$element.toggleClass('ct-input-has-value', !!hasValue);
		};
		self.setInvalid = function (isInvalid) {
			if (isInvalid) {
				$animate.addClass($element, 'ct-input-invalid');
			} else {
				$animate.removeClass($element, 'ct-input-invalid');
			}
		};
	}
}

function cdInputDirective() {
	return {
		restrict: 'E',
		require: ['^?ctInputContainer', '?ngModel'],
		link: postLink
	};

	function postLink(scope, element, attr, ctrls) {
		var containerCtrl = ctrls[0],
			ngModelCtrl = ctrls[1],
			isReadonly = angular.isDefined(attr.readonly);

		if (!containerCtrl) return;
		if (containerCtrl.input) {
			throw new Error("<cd-input-container> can only have *one* <input> child element!");
		}
		containerCtrl.input = element;

		element.addClass('ct-input');

		var isErrorGetter = containerCtrl.isErrorGetter || function () {
				return ngModelCtrl.$invalid && ngModelCtrl.$touched;
			};

		scope.$watch(isErrorGetter, containerCtrl.setInvalid);

		ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
		ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);

		element.on('input', inputCheckValue);

		if (!isReadonly) {
			element
				.on('focus', function (ev) {
					containerCtrl.setFocused(true);
				})
				.on('blur', function (ev) {
					containerCtrl.setFocused(false);
					inputCheckValue();
				});

		}

		scope.$on('$destroy', function () {
			containerCtrl.setFocused(false);
			containerCtrl.setHasValue(false);
			containerCtrl.input = null;
		});

		function ngModelPipelineCheckValue(arg) {
			containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
			return arg;
		}

		function inputCheckValue() {
			// An input's value counts if its length > 0,
			// or if the input's validity state says it has bad input (eg string in a number input)
			containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
		}
	}
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/component-input/src/component-input.js
 ** module id = 352
 ** module chunks = 1
 **/